<template>
  <div>
    <ra-search-box
      class="mt-4"
      :search-fields="busSearchColumns"
      :showBton="false"
      :downLoadBton = "true"
      @autoSearch="searchHnadle"
      @downLoadHandle="downLoadHandle"
    ></ra-search-box>
    <div>
      <div class="wage_table" v-loading="business_loading" v-if="busi_list_data.length>0">
        <el-row>
          <el-col :span="3">
            <div class="grid-content bg-purple-dark">
              <el-row class="table_row" style="display: flex">
                <el-col style="text-align: left">
                  <div class="grid-content bg-purple line" style="display: flex">
                    <div class="worker_name_box">Driver's name</div>
                  </div>
                  <div class="succ_fail_title">
                    <div class="inner_time"></div>
                  </div>
                </el-col>
              </el-row>
              <div v-for="(item,index) in busi_list_data" :key="index">
                <el-row  class="table_row">
                  <el-col :span="3" style="text-align: left;display: flex">
                    <div class="worker_name_box">{{item.name}}</div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="autoWidth">
            <div class="grid-content bg-purple-dark out_scroll_box scroll_list_box">
              <el-row class="table_row time_title_table" id="middle_top">
                <el-col >
                  <div style="white-space: nowrap;line-height: 65px;">
                    <div class="inner_time"
                         :style="{width: inner_auto_width *100 +'%'}" v-for="(item,index) in time_title"
                         :key="index"
                         style="white-space: nowrap;border-bottom: none">{{item.date}}</div>
                  </div>
                  <div class="succ_fail_title">
                    <div class="inner_time" style="border-bottom: none" :style="{width: inner_auto_width *100 +'%'}"  v-for="(item,index) in time_title" :key="index">
                      <div v-if="item.P >-1" class="suc">P</div>
                      <div v-if="item.D >-1" class="fail">D</div>
                      <div v-if="item.F >-1" class="three">F</div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <div v-for="(item,index) in busi_list_data" :key="index">
                <el-row  class="table_row time_title_table  table_bottom " style="border-bottom: none">
                  <el-col>
                    <div style="white-space: nowrap;">
                      <div class="inner_time"  :style="{width: inner_auto_width *100 +'%'}" v-for="(items,indexs) in item.time_data" :key="indexs" style="white-space: nowrap;">
                        <div>{{items.P}}</div>
                        <div>{{items.D}}</div>
                        <div>{{items.F}}</div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="fillWidth">
            <div class="grid-content bg-purple-dark">
              <el-row class="table_row">
                <el-col :span="8">
                  <div class="grid-content bg-purple line">Pickup Quan.</div>
                  <div class="succ_fail_title"><div class="inner_time"></div></div>
                </el-col>
                <el-col :span="8"><div class="grid-content bg-purple line">Delivery Quan.</div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple line">Total Delivery Amount</div></el-col>
              </el-row>
            </div>
            <div v-for="(item,index) in busi_list_data" :key="index">
              <el-row  class="table_row">
                <el-col :span="8" >
                  <span>{{item.pickup_quan}}</span>
                  <!--                </div>-->
                </el-col>
                <el-col :span="8"><div class="grid-content bg-purple">{{item.delivery_quan}}</div></el-col>
                <el-col :span="8"><div class="grid-content bg-purple">{{item.delivery_amount}}</div></el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import {getBusinessList, getDriverDropList,exportBusinessList} from "@/api/wageReview";

export default {
  data(){
    return {
      busSearchColumns:[
        {
          type: 'select',
          prop: 'driver',
          label: 'Driver',
          placeholder: 'All Driver',
          options: []
        },
        {
          type: 'select',
          prop: 'year',
          label: 'Year',
          placeholder: 'All',
          defaultValue: '',
          options: []
        },
        {
          type: 'date',
          prop: 'from_time',
          label: 'From',
          placeholder: 'Select a date',
        },
        {
          type: 'date',
          prop: 'to_time',
          label: 'To',
          placeholder: 'Select a date',
        }
      ],
      business_loading:false,
      bus_start_time:'',
      bus_end_time:'',
      busi_list_data:[],
      fillWidth:"9",
      autoWidth:"12",
      time_title:'',
      driver_id:'',
      init_start_time:'',
      init_end_time:'',
    }
  },
  computed: {
    inner_auto_width() {
      if  (this.time_title.length<= 4){
        return 1/this.time_title.length;
      }else {
        return 0.2028
      }
    },
  },
  async created() {
    this.business_loading = true
    this.option_year = this.getYearFrom2021()
    this.option_year.forEach(item=>{this.busSearchColumns[1].options.push({label:item, value:item})})
    this.busSearchColumns[1].defaultValue = this.input_year
    await this.calculateWeekRangePromise();
    this.getDriverDropListHandle();
    this.getBusinessListHandle();
    console.log(this.busSearchColumns,'busSearchColumns')
    this.busSearchColumns[2].defaultValue = this.bus_start_time
    this.busSearchColumns[3].defaultValue = this.bus_end_time
  },

  methods:{
   async downLoadHandle(params){
      console.log(params)
      if (params.from_time == '' || params.to_time == ''){
      await this.calculateWeekRangePromise()
        this.exportBusinessListHandle(params)
      }else{
        this.bus_start_time = params.from_time
        this.bus_end_time = params.to_time
        this.exportBusinessListHandle(params)
      }
    },
    exportBusinessListHandle(params){
      exportBusinessList({
        start_time:this.bus_start_time,
        end_time:this.bus_end_time,
        driver_id:params.driver
      }).then(res => {
        if  (res.code === 200){
          this.download(res.data.file)
          this.$message({
            type:"success",
            message:res.msg
          })
        }else {
          this.$message({
            message:res.msg,
            type:'error'
          })
        }
      })
    },
    download(url){
      const link = document.createElement('a')
      link.href = 'https://plus.escroud.com//storage/' + url
      link.setAttribute('download', '文件名字' + Date.now() + '.xls') // 下载文件的名称及文件类型后缀
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) // 下载完成移除元素
    },
    searchHnadle(a){
      const isWithinTwoWeeksResult = this.isWithinTwoWeeks(a);
      if (!isWithinTwoWeeksResult) {
        this.$message({
          type:"error",
          message:'The maximum selection range is 14 days.'
        })
      }else {
        const driverOption = this.busSearchColumns[0].options.find(item => item.label === a.driver);
        if (driverOption) {
          this.driver_id = driverOption.value;
        }
        this.bus_start_time = a.from_time
        this.bus_end_time = a.to_time
        this.getBusinessListHandle()
      }
    },
    isWithinTwoWeeks(data) {
      const { from_time, to_time } = data;
      console.log(!from_time && !to_time)
      if (!from_time && !to_time) {
        data.from_time = this.init_start_time;
        data.to_time = this.init_end_time;
        return true;
      }
      // 将字符串转换为 Date 对象
      const fromDate = new Date(from_time);
      const toDate = new Date(to_time);

      // 计算两个日期之间的毫秒数
      const timeDiff = toDate.getTime() - fromDate.getTime();

      // 将毫秒数转换为天数
      const daysDiff = timeDiff / (1000 * 60 * 60 * 24);

      // 检查天数差是否小于或等于 14
      return daysDiff <= 14;
    },

    getBusinessListHandle(){
      getBusinessList({
        start_time:this.bus_start_time,
        end_time:this.bus_end_time,
        driver_id:this.driver_id
      }).then(res => {
        this.business_loading = false
        if (res.code == 200){
          const obj = {}
          res.data.forEach(v=>{
            v.show_rate_input = false
            for (let key of Object.keys(v.data)) {
              if(!Object.prototype.hasOwnProperty.call(obj, key)) {
                obj[key] = v.data[key]
              }
            }
            v.time_data =obj
          })
          this.busi_list_data = res.data
          //需要正对不同司机的不同时间做数组对齐 比如a司机的时间1 有任务；b司机的时间2有任务，那么需要对a司机的时间2、b司机的时间1做空处理
          //这里选择遍历time_title对象，取time_title的key 跟每个司机中的data 做比较，如果不相等 则添加空；注意需要跟原本 0 项做区分
          const arrPrototype = Object.keys(obj)
          this.busi_list_data.forEach((item, index) => {
            for(let key of arrPrototype) {
              if (!Object.prototype.hasOwnProperty.call(item.data, key)){
                item.data[key] = {
                  total_failure:0,
                  total_success:0
                }
              }
            }
            let transformedData = [];
            for (const [date, values] of Object.entries(item.data)) {
              let transformedItem = { date, ...values };
              transformedData.push(transformedItem);
            }
            let sortedData = transformedData.sort((a, b) => {
              return arrPrototype.indexOf(a.date) - arrPrototype.indexOf(b.date);
            });
            item.time_data = sortedData
          })
          this.$nextTick(() => {
            this.time_title = this.busi_list_data[0]?.time_data
            let length = this.time_title?.length
            console.log(length,'sss')
            switch (length){
              case 1:
                this.autoWidth = 3
                this.fillWidth = 18
                break;
              case 2:
                this.autoWidth = 4
                this.fillWidth = 17
                break;
              case 3:
                this.autoWidth = 6
                this.fillWidth = 15
                break;
              case 4:
                this.autoWidth = 8
                this.fillWidth = 13
                break;
              case 5:
                this.autoWidth = 10
                this.fillWidth = 11
                break;
              case 6:
                this.autoWidth = 12
                this.fillWidth = 9
                break;
              case 7 :
                this.autoWidth = 12
                this.fillWidth = 9
                break;
            }
            if  (length >7){
              this.autoWidth = 12
              this.fillWidth = 9
            }
          })

        }else {
          this.$message({
            type :'error',
            message:res.msg
          })
        }
      })
    },
    //获取从2021 到当前的年份
    getYearFrom2021(){
      const currentYear = new Date().getFullYear();
      this.input_year = currentYear
      const startYear = 2021;
      const years = [];
      for (let year = startYear; year <= currentYear; year++) {
        years.push(year);
      }
      return years;
    },
    calculateWeekRangePromise() {
      return new Promise((resolve, reject) => {
        try {
          this.calculateWeekRange();
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    calculateWeekRange() {
      let date = new Date();
      let currYear = date.getFullYear();
      let currMonth = date.getMonth();
      let currWeekDay = date.getDate();
      let currDate = date.getDay(); // 当前日期是星期几（0 表示星期日，1 表示星期一，依此类推）

      // 计算本周的第一天（星期一）
      let weekStartDate = new Date(
        currYear,
        currMonth,
        currWeekDay - currDate + 1
      );

      // 计算本周的最后一天（星期日）
      let weekEndDate = new Date(
        currYear,
        currMonth,
        currWeekDay - currDate + 7
      );

      // 获取起始日期的月份和日期
      let startMonth = weekStartDate.getMonth() + 1;
      let startDate = weekStartDate.getDate();

      // 获取结束日期的月份和日期
      let endMonth = weekEndDate.getMonth() + 1;
      let endDate = weekEndDate.getDate();

      // 格式化日期
      this.bus_start_time = `${currYear}-${startMonth}-${startDate}`;
      this.bus_end_time = `${currYear}-${endMonth}-${endDate}`;
      this.init_start_time = this.bus_start_time;
      this.init_end_time = this.bus_end_time;
    },
    getDriverDropListHandle(){
      getDriverDropList({
        start_time:this.bus_start_time,
        end_time:this.bus_end_time,
      }).then(res=>{
        if (res.code == 200){
          res.data.forEach(v=>{
            this.busSearchColumns[0].options.push({
              label:v.name,
              value:v.driver_id
            })
          })
          this.busSearchColumns[0].options.push({
            label:'All',
            value:''
          })
        }

      })
    }
  }
}
</script>
<style scoped lang="less">
.current{
  ::v-deep .el-date-table td.available:hover{
    color: #FFFFFF !important;
  }
}
.wage_table{
  padding: 0 8px;
  background: #FFFFFF;
  border-radius: 16px;
  margin-top: 16px;

  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #1F2D42;
  line-height: 20px;
  .table_row{
    line-height: 64px;
    border-bottom: 1px solid #E0E0E0;
    .line{
      border-bottom: 1px solid #E0E0E0;
    }
    img{
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
    .red_point{
      position: absolute;
      top: -2px;
      right: 14px;
      width: 5px;
      height: 5px;
      background-color: #EB3F3F;
      border-radius: 50%;

    }
    .worker_name_box{
      white-space:nowrap;
      display: flex;
      margin-left: 16px;
    }
  }
  .time_title_table{
    text-align: left;
    .inner_time{
      text-align: center;
    }
  }
  .table_bottom{
    .inner_time{
      border-bottom: 1px solid #E0E0E0!important;
    }
  }
  .time_title_box{
    line-height: 20px;
    overflow-x: hidden;
  }
  .inner_time{
    display: inline-block;
    //width: 14.28%;
    div{
      width: 33.33%;
      display: inline-block;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
    }
  }
  .succ_fail_title{
    white-space: nowrap;
    //overflow-x: hidden;
    height: 28px;
    line-height: 28px;
    .inner_time{
      display: inline-block;
      //width: 14.28%;
      .suc{
        background-color: #82D237;
        width: 33.33%;
      }
      .fail{
        background-color: #E95646;
        width: 33.33%;
      }
      .three{
        background-color: #CCCCCC;
        width: 33.33%;
      }
      div{
        display: inline-block;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
  }

  .change_input{
    cursor: pointer;
    /deep/ .el-input__inner{
      text-align: center;
      border-radius: 10px;
    }
  }
  .out_scroll_box{
    width: 100%;
    overflow: auto;
    max-width: 100%;
  }
}
/deep/.el-col-2 {
  width: 5%;
}
/deep/.el-col-3{
  width: 11%;
}
/deep/.el-col-11 {
  width: 44.83333%;
}
/deep/.el-col{
  min-width: 40px;
}
</style>
